import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Overview',
      href: '/en/Outdoor_Cameras/IN-5907_HD/',
    },
    {
      text: 'Specifications',
      href: '/en/Outdoor_Cameras/IN-5907_HD/Technical_Specifications/',
    },
    {
      text: 'Features',
      href: '/en/Outdoor_Cameras/IN-5907_HD/Product_Features/',
    },
    {
      text: 'Installation',
      href: '/en/Outdoor_Cameras/IN-5907_HD/Quick_Installation/',
    },
    {
      text: 'P2P',
      href: '/en/Outdoor_Cameras/IN-5907_HD/Point2Point/',
    },
    {
      text: 'Lense Adjustment',
      href: '/en/Outdoor_Cameras/IN-5907_HD/Lense_Adjustment/',
    },
    {
      text: 'Usermanual',
      href: '/en/Outdoor_Cameras/IN-5907_HD/Usermanual/',
    },
    {
      text: '◄ Outdoor Cameras',
      href: '/en/Outdoor_Cameras/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-5907 HD Online Usermanual Chapters"
      />
      <EuiSpacer />
    </Fragment>
  );
}